import React from "react";
import { GlobalButton } from "../../../../global/forms/GlobalFormFields";
import { canCancelSchedule, canMarkScheduleCompleted } from "../../utils/scheduleStatuses";

export default function ScheduleActions({
  schedule,
  permissions,
  isAdmin = false,
  onView,
  onEdit,
  onDelete,
  onComplete,
  onCancel,
}) {
  if (!schedule) return null;

  const showComplete = !isAdmin && permissions?.canComplete && canMarkScheduleCompleted(schedule);
  const showCancel = !isAdmin && permissions?.canCancel && canCancelSchedule(schedule);

  return (
    <div className="ub-table-actions">
      {onView ? (
        <GlobalButton variant="ghost" size="sm" onClick={() => onView(schedule)}>
          View
        </GlobalButton>
      ) : null}
      {permissions?.canEdit && onEdit ? (
        <GlobalButton variant="ghost" size="sm" onClick={() => onEdit(schedule)}>
          Edit
        </GlobalButton>
      ) : null}
      {showComplete ? (
        <GlobalButton variant="ghost" size="sm" onClick={() => onComplete?.(schedule)}>
          Mark Completed
        </GlobalButton>
      ) : null}
      {showCancel ? (
        <GlobalButton variant="danger" size="sm" onClick={() => onCancel?.(schedule)}>
          Cancel
        </GlobalButton>
      ) : null}
      {isAdmin && permissions?.canDelete && onDelete ? (
        <GlobalButton variant="danger" size="sm" onClick={() => onDelete(schedule)}>
          Delete
        </GlobalButton>
      ) : null}
    </div>
  );
}
